/**
 * @generated SignedSource<<092d564f50562bdfde371e4db0475185>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ActivitiesObjectType {
  ISSUE = "ISSUE",
  PAGE = "PAGE",
  BLOGPOST = "BLOGPOST",
  WHITEBOARD = "WHITEBOARD",
  DATABASE = "DATABASE",
  EMBED = "EMBED",
}
export enum ActivityEventType {
  ASSIGNED = "ASSIGNED",
  UNASSIGNED = "UNASSIGNED",
  VIEWED = "VIEWED",
  COMMENTED = "COMMENTED",
  UPDATED = "UPDATED",
  CREATED = "CREATED",
  LIKED = "LIKED",
  TRANSITIONED = "TRANSITIONED",
  PUBLISHED = "PUBLISHED",
  EDITED = "EDITED",
}
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_events_ActivitiesEvent =
  {
    __typename?: "ActivitiesEvent";
    eventType: ActivityEventType | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary =
  {
    __typename?: "FavouritedSummary";
    isFavourite: boolean | null;
    favouritedDate: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_lastcontributed_ContributionStatusSummary =
  {
    __typename?: "ContributionStatusSummary";
    status: string | null;
    when: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_scheduled_ScheduledPublishSummary =
  {
    __typename?: "ScheduledPublishSummary";
    isScheduled: boolean | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser =
  {
    __typename?: "ContentMetadata_CurrentUserMetadataProvider_currentuser";
    favourited: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_favourited_FavouritedSummary | null;
    lastcontributed: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_lastcontributed_ContributionStatusSummary | null;
    scheduled: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser_scheduled_ScheduledPublishSummary | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata =
  {
    __typename?: "ContentMetadata";
    currentuser: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata_currentuser_ContentMetadata_CurrentUserMetadataProvider_currentuser | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    editui: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_editorVersion_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_editorVersion_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    key: string | null;
    name: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty =
  {
    __typename?: "JsonContentProperty";
    id: string | null;
    key: string | null;
    value: string | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_emoji_PaginatedJsonContentPropertyList =
  {
    __typename?: "PaginatedJsonContentPropertyList";
    nodes: Array<RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_emoji_PaginatedJsonContentPropertyList_nodes_JsonContentProperty | null> | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content =
  {
    __typename?: "Content";
    id: string | null;
    type: string | null;
    subType: string | null;
    title: string | null;
    status: string | null;
    blank: boolean;
    metadata: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_metadata_ContentMetadata;
    links: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
    editorVersion: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_editorVersion_PaginatedJsonContentPropertyList | null;
    space: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_space_Space | null;
    emoji: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content_emoji_PaginatedJsonContentPropertyList | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject =
  {
    __typename?: "ActivitiesObject";
    id: string;
    events: Array<RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_events_ActivitiesEvent> | null;
    content: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject_content_Content | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem =
  {
    __typename?: "ActivitiesItem";
    id: string;
    timestamp: string | null;
    object: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem_object_ActivitiesObject | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge =
  {
    __typename?: "ActivityEdge";
    cursor: string;
    node: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge_node_ActivitiesItem | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_pageInfo_ActivityPageInfo =
  {
    __typename?: "ActivityPageInfo";
    hasNextPage: boolean;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection =
  {
    __typename?: "ActivitiesConnection";
    edges: Array<RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_edges_ActivityEdge | null> | null;
    pageInfo: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection_pageInfo_ActivityPageInfo;
  };
export type RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities =
  {
    __typename?: "MyActivities";
    all: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities_all_ActivitiesConnection | null;
  };
export type RecentlyWorkedOnQuery_activities_Activities = {
  __typename?: "Activities";
  myActivities: RecentlyWorkedOnQuery_activities_Activities_myActivities_MyActivities | null;
};
export type RecentlyWorkedOnQuery_Query = {
  __typename?: "Query";
  activities: RecentlyWorkedOnQuery_activities_Activities | null;
};
export type RecentlyWorkedOnQueryVariables = Exact<{
  cloudId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  eventTypes?: InputMaybe<Array<ActivityEventType> | ActivityEventType>;
  objectTypes?: InputMaybe<Array<ActivitiesObjectType> | ActivitiesObjectType>;
}>;
export type RecentlyWorkedOnQuery = RecentlyWorkedOnQuery_Query;
